import { i18n } from '@/common/utils/i18n'
import VueI18n from '@/i18n/locale'
export const formData = {
  visitMode: 1
}
export const shopPicDescList = [
  {
    way: 1,
    desc: VueI18n.t('FoodB_0_Please_upload_ziBz' /**  请上传通话记录截屏 */)
  },
  {
    way: 2,
    desc: i18n.gettext('建议拍摄店面照片')
  },
  {
    way: 3,
    desc: VueI18n.t('FoodB_0_Please_upload_BZIQ'/**  请上传聊天记录截屏 */)
  }, {
    way: 4,
    desc: VueI18n.t('FoodB_0_Please_upload_roTo'/** '请上传邮件记录截屏 */)
  }, {
    way: 5,
    desc: VueI18n.t('FoodB_0_Please_upload_dcPG' /** 请上传短信记录截屏 */)
  }
]
const allModeOptions = [
  {
    value: 1,
    label: i18n.gettext('电话'),
    showFn ({ country, status }) {
      return !(country === 'JP' && !['follow', 'draft', 'auditing', 'auditFail', 'signed'].includes(status))
    }
  }, {
    value: 2,
    label: i18n.gettext('线下')
  }, {
    value: 3,
    label: VueI18n.t('FoodB_0_WhatsApp_dmMD'/** WhatsApp */),
    showFn ({ country, status }) {
      return !(country === 'JP' && !['follow', 'draft', 'auditing', 'auditFail', 'signed'].includes(status))
    }
  }, {
    value: 4,
    label: VueI18n.t('FoodB_0_Mail_SUKZ'/** 邮件 */)
  }, {
    value: 5,
    label: VueI18n.t('FoodB_0_SMS_yOMB'/** 短信 */)
  }
]
let modeOptions = []
const defaultConfig = [
  {
    label: i18n.gettext('拜访方式'),
    type: 'rich-radio-group',
    prop: 'visitMode',
    props: {
      options: modeOptions
    },
    rules: [['required', i18n.gettext('拜访方式')]]
  },
  {
    label: i18n.gettext('拜访内容'),
    type: 'visitSelProp',
    prop: 'visitTemplate',
    props: {
      placeholder: i18n.gettext('请选择'),
      map: {}
    },
    rules: [['required', i18n.gettext('拜访内容')]]
  }
]
export function getDefaultConfig (showStatus) {
  let arr = showStatus.split('_')
  const obj = {
    country: arr[0],
    status: arr[1],
    showStatus: arr.splice(0, 2).join('_')
  }
  modeOptions.length = 0
  modeOptions.push(...allModeOptions.filter(item => {
    return !item.showFn || item.showFn(obj)
  }))
  return defaultConfig
}

// 拜访类型 只是作为数据提交 目前受 拜访内容的影响
export const visitTypeConfig = [
  {
    value: 1, // 合作拜访
    showFn (key) {
      return [1, 2, 6, 7].includes(key)
    }
  }, {
    value: 7, // 日常拜访 常规拜访
    showFn (key) {
      return [5].includes(key)
    }
  }, {
    value: 9, // 经营拜访
    showFn (key) {
      return [3, 4].includes(key)
    }
  }
]

// 提交成功任务
export function getComplateTaskMap (shopId) {
  return {
    dataInput: {
      title: i18n.gettext('资料录入'),
      link: {
        path: '/v2/bizopp-detail',
        query: {
          shopId: shopId
        }
      }
    },
    visitPlan: {
      title: i18n.gettext('添加拜访计划'),
      link: {
        path: '/add-visit-plan',
        query: {
          shopId: shopId
        }
      }
    }
  }
}
export const BIZOPP_STATUS_MAP = {
  '1': 'follow', // 跟进中
  '2': 'draft', // 草稿中
  '3': 'auditing', // 审核中
  '4': 'auditFail', // 审核未通过
  '5': 'signed', // 已签约
  '8': 'audited', // 审核通过
  '9': 'approved', // 已核准
  '10': 'signature' // 已签章
}
export const VISIT_WAY_MAP = {
  '1': 'online', // 电话
  '2': 'offline', // 线下
  '3': 'WhatsApp', // WhatsApp
  '4': 'email',
  '5': 'message' // 短信
}
export const VISIT_CONTENT_MAP = {
  '1': 'phoneTalk', // 电话预约
  '7': 'firstVisit', // 陌拜
  '6': 'formalVisit', // 正式拜访
  '5': 'collect', // 信息收集
  '2': 'signVisit', // 合作谈判
  '3': 'proviedPad', // 设备铺设
  '4': 'dailyCare'  // 日常维护
}

// 提交key
const subKeys = [
  'visitTime',
  'visitContent',
  'visitMode',
  'visitTemplate',
  'visitType',
  'visitResult', // 结果
  'shopPics',
  'otherReason',
  'repeatShopId'
  // 'visitReason',
  // 'lat',
  // 'lng',
]
const baseInfoKeys = [
  'visitObjectName',
  'visitObjectTitle',
  'visitObjectPhone',
  'visitFellowName',
  'visitObjectRoleId'
]
const bizoppExtKeys = [
  'bizDayTime',
  'isNeedPad',
  'customerPrice'
]
const padExtKeys = [
  'isNeedPic',
  'padModel',
  'padIMEI',
  'padTransactor'
]

export const submitConfig = {
  subKeys,
  baseInfoKeys,
  bizoppExtKeys,
  padExtKeys
}

export const MXSameCountryGroup = ['MX', 'BR', 'CR', 'CO', 'DO', 'CL', 'PE']

export const countryPhonepreText = {
  MX: '+52',
  BR: '+55',
  JP: '+81',
  CR: '+506',
  CO: '+57',
  DO: '+1',
  CL: '+56',
  PE: '+51'
}
